import type { InjectionKey } from 'vue'

/**
 * Optional override for what clicking an agency node in the structure tree
 * does. Left unset, `AgencyListItem` falls back to navigating to the routed
 * agency detail page (the structure view's behavior). The AdministrationModal
 * agency-structure panel provides one that opens the global AgencyDetailModal
 * via `?agency=<id>` instead — so the recursive tree needn't thread an emit
 * up through `AgencyGroupListItem`.
 */
export type AgencyNodeSelect = (agencyId: string) => void

export const agencyNodeSelectKey: InjectionKey<AgencyNodeSelect> =
  Symbol('agencyNodeSelect')
